import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import { Row, Col, DatePicker } from 'antd';
import 'moment/locale/es-mx';
import locale from 'antd/es/date-picker/locale/es_ES';
import { STATES } from '../../config/constants/contractStates';
import { LIST_PAGINATE_CONTRACTS, PERSIST_DATE_FILTER } from '../../state/lease_contract/types';
import { RESOURCE } from '../../config/constants/alerts';
import PropTypes from 'prop-types';

const { RangePicker } = DatePicker;

const FilterTableByDate = ({
  activeTab,
  listContracts,
  persistedPage,
  persistedPageSize,
  persistDateFilter,
  persistedStartDate,
  persistedEndDate,
}) => {

  const [activeState, setActiveState] = useState(STATES.HALT);
  const [dateRange, setDateRange] = useState([persistedStartDate, persistedEndDate]);

  useEffect(() => {
    listContracts({
      limit: persistedPageSize,
      page: persistedPage,
      statusName: activeState,
      startDate: '',
      endDate: ''
    });
    persistDateFilter({ startDate: '', endDate: '', activeState: null });
    setDateRange([]);
  }, [activeState]);

  useEffect(() => {
    const states = {
      0: STATES.HALT,
      1: STATES.CREATED,
      2: STATES.AWAITING_VALIDATION,
      3: STATES.SENDED,
      4: STATES.AWAITING_SIGN,
      5: STATES.AWAITING_NOTARY,
      6: STATES.CANCELED,
      7: STATES.OBJECTED,
      8: STATES.FINALIZED,
      9: ''
    };
    setActiveState(states[activeTab]);
  }, [activeTab]);

  const getPaginatedByDate = (dateRange) => {
    if (dateRange && dateRange[0] && dateRange[1]) {
      const startDate = `${new Date(dateRange[0]).toISOString().slice(0, dateRange[0].toISOString().indexOf('T'))} 00:00:00`;
      const endDate = `${new Date(dateRange[1]).toISOString().slice(0, dateRange[1].toISOString().indexOf('T'))} 11:59:59`;
      persistDateFilter({ startDate: dateRange[0], endDate: dateRange[1], activeState });
      setDateRange([dateRange[0], dateRange[1]]);
      listContracts({
        limit: persistedPageSize,
        page: persistedPage,
        statusName: activeState,
        startDate: startDate,
        endDate: endDate
      });
    }
    if (dateRange === null) {
      setDateRange([]);
      persistDateFilter({ startDate: '', endDate: '', activeState: null });
      listContracts({
        limit: 10,
        page: persistedPage,
        statusName: activeState,
        startDate: '',
        endDate: ''
      });
    }
  };

  const PaginateForm = () => (
    <Fragment>
      <Row>
        <Col className="mb-2" span={24} >
          <p>Filtrar por rango de fechas:</p>
          <RangePicker
            locale={locale}
            onCalendarChange={getPaginatedByDate}
            value={dateRange}
          />
        </Col>
      </Row>
    </Fragment>
  );

  return (
    <PaginateForm />
  );
};

FilterTableByDate.propTypes = {
  activeTab: PropTypes.number.isRequired,
  listContracts: PropTypes.func.isRequired,
  persistedPage: PropTypes.number.isRequired,
  persistedPageSize: PropTypes.number.isRequired,
  persistDateFilter: PropTypes.func.isRequired,
  persistedStartDate: PropTypes.string.isRequired,
  persistedEndDate: PropTypes.string.isRequired,
  dateRange: PropTypes.array
};

const data = (state) => ({
  persistedPage: state.contract.persistedPage,
  persistedPageSize: state.contract.persistedPageSize,
  persistedStartDate: state.contract.startDate,
  persistedEndDate: state.contract.endDate,
});

const action = (dispatch) => ({
  listContracts: (params) => dispatch({ type: LIST_PAGINATE_CONTRACTS, payload: { params, resource: RESOURCE.GET_CONTRACT_LIST } }),
  persistDateFilter: (params) => dispatch({ type: PERSIST_DATE_FILTER, payload: params }),
});

export default connect(data, action)(FilterTableByDate);